<template>
  <v-container
    fluid
    mx-auto
    px-3
    py-5
    grid-list-xxl
  >
    <Post
      :right="right"
      :lift="lift"
    />
  </v-container>
</template>

<script>
import Vue from 'vue'
import Post from './LiftPost.vue'

export default Vue.extend({
  name: 'LiftPostSection',
  components: { Post },
  props: {
    lift: {
      type: Object,
      required: true
    },
    right: Boolean
  }
})
</script>

<style
  scoped
  lang="scss"
>

</style>